import React from 'react';
import { Container } from 'react-bootstrap';
import QRCode from 'qrcode.react';
import BadgeFactory from './BadgeFactory';

export const BadgeGeneratorPage: React.FC = () => {
  return (
    <Container>
      <div className="mt-5">
        <QRCode
          value={JSON.stringify(BadgeFactory.Create())}
          level={'L'}
          renderAs={'svg'}
        />
      </div>
    </Container>
  );
};
